import {
  useFindOneUtilityQuery,
  useRemoveUtilityMutation,
} from '../../api/api-hooks';
import { Grid, TextField } from '@mui/material';
import ItemOptionsBar from '../../components/ItemOptionsBar';
import { nullStringCheck } from '../../utils/stringManipulation';
import { Item } from '../../utils/sharedTypes';
import { UtilitiesForm } from './utilitiesTypes';
import useUtilitiesCreator from './useUtilitiesCreator';
import useUtilitiesUpdater from './useUtilitiesUpdater';
import { utilityValidator } from './utilitiesUtils';
import { useState } from 'react';

interface Props {
  selectedUtilities: Item[];
  setSelectedUtilities: React.Dispatch<React.SetStateAction<Item[]>>;
}

const addFormInitialState: UtilitiesForm = {
  name: undefined,
  link: undefined,
};

const UtilitiesOptionsBar = ({
  selectedUtilities,
  setSelectedUtilities,
}: Props) => {
  const [deleteUtils] = useRemoveUtilityMutation();
  const utilCreator = useUtilitiesCreator();
  const utilUpdater = useUtilitiesUpdater();
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  return (
    <>
      <ItemOptionsBar
        selectedItems={selectedUtilities}
        setSelectedItems={setSelectedUtilities}
        handlerMiddleware={() => ({})}
        itemValidator={utilityValidator}
        itemDeleter={deleteUtils}
        itemName='Utilities'
        editModalOpen={editModalOpen}
        setEditModalOpen={setEditModalOpen}
        formInstructions='Name and Link are required.'
        addFormInitialState={addFormInitialState}
        childrenCreator={(addFormState: UtilitiesForm, handler: any) => (
          <Grid container direction='column' spacing={1}>
            <Grid item>
              <TextField
                margin='dense'
                name='name'
                label='Utilities Name'
                fullWidth
                value={nullStringCheck(addFormState.name)}
                onChange={handler}
              />
            </Grid>
            <Grid item>
              <TextField
                margin='dense'
                name='link'
                label='Utilities Link'
                fullWidth
                value={nullStringCheck(addFormState.link)}
                onChange={handler}
              />
            </Grid>
          </Grid>
        )}
        itemCreator={utilCreator}
        itemGetter={useFindOneUtilityQuery}
        itemUpdater={utilUpdater}
      />
    </>
  );
};

export default UtilitiesOptionsBar;
